import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { base44 } from "@/api/base44Client";

const TRACKED_PREFIXES = [
  "/solutions",
  "/roi-calculator",
  "/industries",
  "/validation-intake",
  "/contact",
  "/resources",
  "/whitepapers",
  "/gap-assessment",
];

function getVisitorId() {
  let id = localStorage.getItem("lc_visitor_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("lc_visitor_id", id);
  }
  return id;
}

export default function useInterestTracking() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.toLowerCase();
    if (!TRACKED_PREFIXES.some((p) => path.startsWith(p))) return;

    // Only track each page once per session to avoid noise
    const sessionKey = `lc_tracked_${path}`;
    if (sessionStorage.getItem(sessionKey)) return;
    sessionStorage.setItem(sessionKey, "1");

    base44.functions
      .invoke("logInteraction", {
        visitor_id: getVisitorId(),
        page_path: location.pathname,
        activity_type: "page_view",
      })
      .catch(() => {});
  }, [location.pathname]);
}